import { AIRecommendation } from '@hakimo-ui/hakimo/feature-shared';
import { UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';

interface Props {
  alarmId: string;
  timeZone: string;
}

export function AIRecommendationWrapper(props: Props) {
  const { alarmId, timeZone } = props;
  return (
    <div className="space-y-1">
      <h2 className="flex h-9 items-center pl-1 font-bold">
        AI Recommendation
      </h2>
      <AIRecommendation
        alarmId={alarmId}
        product={UnifiedMonitoringProduct.REMOTE_GUARDING}
        timeZone={timeZone}
      />
    </div>
  );
}

export default AIRecommendationWrapper;
